import {CardElement, Elements, PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import React, {useEffect, useState} from "react";
import {createPaymentIntent, createSubscription} from "apis/PaymentService";
import {useAppSelector} from "store/hooks";
import BenevvButton from "components/buttons/BenevvButton/BenevvButton";
import BenevvSubmitField from "components/forms/BenevvSubmitField/BenevvSubmitField";
import {useDispatch} from "react-redux";
import {updateShowThankYou, updateShowThankYouScreen} from "store/ui/thankYouScreen/thankYouScreen.slice";
import {updateShowError} from "store/ui/errorPopupScreen/errorPopupScreen.slice";


function StripeForm() {
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const user = useAppSelector(state => state.user);
  const plan = useAppSelector(state => state.subscriptionPlan);

  const buttonStyles = {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '30px',
    width: '100%'
  }

  // RELATED DOCUMENTATION: https://stripe.com/docs/stripe-js/react
  // AND: https://stripe.com/docs/payments/payment-element/migration?integration-path=one-time
  // https://stripe.com/docs/billing/subscriptions/build-subscriptions?ui=elements (FOR FRONT-END AND BACK-END)
  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // stripe.js has not yet loaded.
    // make sure to disable form submission until stripe.js has loaded.
    if (!stripe || !elements) return;
    // const response = await createSubscription(user.stripeCustomerId, plan.stripePriceId);

    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: 'https://benevweb.external.smarttwigs.io/',
      }
    });


    // show error to your customer (for example, payment details incomplete)
    if (result.error) {
      dispatch(updateShowError({
        showErrorPopup: true,
        errorMessage: result.error.message || ''
      }));
    } else {
      dispatch(updateShowThankYouScreen(true));
    }
  }


  return (
    <div className={'checkout-payment-details'}>
      <form onSubmit={onSubmit}>
        <PaymentElement/>
        <BenevvSubmitField value={'Purchase'} style={buttonStyles}/>
      </form>
    </div>
  )
}

export default StripeForm;
